import { Component, AfterViewInit, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'dialog-back',
  template: ''
})
export class DialogBackComponent implements AfterViewInit {
  constructor(private cd: ChangeDetectorRef) {
  }

  ngAfterViewInit() {
    this.cd.detach();

  }
}
